import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { PayWithCodeComponent } from './pay-with-code.component';

// TODO - remove when paymentPanel STAB-908
export const ngxPayWithCodeModule = angular.module('ngxPayWithCodeModule', [])
	.directive('ngxPayWithCode', downgradeComponent({ component: PayWithCodeComponent }))
	.name;
